import React from "react"

export const useEffectAfterMount = (callback: () => void, deps: any[]) => {
  const isMounted = React.useRef(false)
  React.useEffect(() => {
    if (isMounted.current) {
      return callback()
    } else {
      isMounted.current = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  // reset on unmount; in React 18, components can mount again
  React.useEffect(() => {
    return () => {
      isMounted.current = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
